/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class AddEditStatusModel {

        public processStatusGroup: ProcessStatusGroup;

        public existingStatus: boolean;
        public deleteStatusCode: boolean;

        
        constructor(processStatusGroup?: ProcessStatusGroup) {
            if (processStatusGroup) {
                this.processStatusGroup = processStatusGroup;
                this.existingStatus = true;
                this.deleteStatusCode = false;
            } else {
                this.existingStatus = false;
                this.processStatusGroup = new models.ProcessStatusGroup();
            }
        }
    }
}